import React, { useEffect, useState } from "react";
import "./MJChatBubble.css";

const MJChatBubble = ({
  msg,
  timer // number of seconds
}) => {
  const [show, setShow] = useState(true);
  const theme = localStorage.getItem('theme') || 'pvrTheme';
  const primaryColor = theme === 'inoxTheme' ? '#DCE2EF' : '#FFF0D6';



  // useEffect(() => {
  //   if (timer <= 0) return; // no auto-hide if 0

  //   const hideTimer = setTimeout(() => {
  //     setShow(false);
  //     localStorage.setItem("showbubblemessage", "true");
  //   }, timer * 1000);

  //   // cleanup on unmount or when timer changes
  //   return () => clearTimeout(hideTimer);
  // }, [timer]);

  useEffect(() => {
  if (timer <= 0) return;

  const hideTimer = setTimeout(() => {
    setShow(false);
    localStorage.setItem("bubbleHiddenTime", Date.now().toString());
    localStorage.setItem("showbubblemessage", "true");
  }, timer * 1000);

  return () => clearTimeout(hideTimer);
}, [timer]);

useEffect(() => {
  const hiddenTime = localStorage.getItem("bubbleHiddenTime");
  if (hiddenTime) {
    const now = Date.now();
    const hours24 = 24 * 60 * 60 * 1000;

    if (now - parseInt(hiddenTime) > hours24) {
      localStorage.setItem("showbubblemessage", "false");
      localStorage.removeItem("bubbleHiddenTime");
      setShow(true);
    } else {
      setShow(false);
    }
  }
}, []);


  if (!show) return null;

  return (
    <div className="mj-mini-wrapper">
      <div className="mj-mini-bubble" style={{backgroundColor:primaryColor}}>
        {msg}
      </div>
    </div>
  );
};

export default MJChatBubble;
